export const RETRY_FETCH = 'salesTurnovers/RETRY_FETCH';
